import { useLocation } from 'react-router-dom';

export function useQueries() {
    return new URLSearchParams(useLocation().search);
}
